import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/i18n/settings';

export function normalizeLanguage(language?: string | null): SupportedLanguage {
  if (language && SUPPORTED_LANGUAGES.includes(language as SupportedLanguage)) {
    return language as SupportedLanguage;
  }

  return DEFAULT_LANGUAGE;
}

export function withLanguageParam(href: string, language: SupportedLanguage): string {
  const [pathWithQuery, hash] = href.split('#');
  const [path, query] = pathWithQuery.split('?');
  const params = new URLSearchParams(query || '');

  params.set('lang', language);

  const queryString = params.toString();
  const nextHref = `${path}${queryString ? `?${queryString}` : ''}`;

  return hash ? `${nextHref}#${hash}` : nextHref;
}
